const sync = {
	name: 'Updates',
	fields: {
		started_at: 'Started at',
		ended_at: 'Ended at',
		total_count: 'Updates',
	},
}

export default sync
